import { platformInfo } from '@gem/utils';

import Tasks from 'APP/Tasks';
import { PayloadType } from 'APP/model/message/messageModel.types';
import { MlsStorageService } from 'SERVICES/mlsStorageService/MlsStorageService';
import Entities from 'STORE';
import { ChatMessage } from 'STORE/Messages/Message/ChatMessage/ChatMessage';

import { getLinkPreview } from './getLinkPreview';

export async function editTextMessage(groupId: string, message: ChatMessage): Promise<boolean> {
  const inputPanel = Entities.InputPanelsStore.getById(groupId);
  if (!inputPanel) {
    return false;
  }

  if (inputPanel.isEmptyValue) {
    return false;
  }

  const newText = inputPanel.markdownValue.trim();
  const oldPayload = message.payload.toJSON();

  if (message.payload.text.trim() === newText) {
    Tasks.messaging.clearInputPanel(groupId);
    return false;
  }

  const mlsGroup = MlsStorageService.loadGroup(groupId);

  if (message.payload.payloadType === PayloadType.E2ee && mlsGroup) {
    const currentEpoch = mlsGroup.currentEpoch();
    const encodedPayload = await Tasks.e2ee.getE2eePayloadData(groupId, newText);
    message.payload.e2eeData = encodedPayload?.payload || '';
    message.payload.selfData = encodedPayload?.selfPayload || '';
    message.payload.epoch = Number(currentEpoch);
    message.payload.senderDeviceId = platformInfo.deviceId;
    message.payload.setDecodedText(newText);
  } else {
    message.payload.text = newText;
    message.payload.linkPreview = getLinkPreview(groupId);
    message.payload.linkPreviewCancelled = inputPanel.linkPreviewCancelled;
    message.payload.userMentions = Tasks.messaging.getMentionsDataFromText(newText);
  }

  const canEdit = Tasks.messaging.canSendMessage({
    groupId,
    isNewMessage: false,
    payload: message.payload,
  });

  if (!canEdit.result && message.payload.payloadType !== PayloadType.E2ee) {
    message.payload.text = oldPayload.text;
    message.payload.linkPreview = oldPayload.linkPreview;
    message.payload.linkPreviewCancelled = oldPayload.linkPreviewCancelled;
    message.payload.userMentions = oldPayload.userMentions;

    canEdit.error && Tasks.app.showToast(canEdit.error);
    return false;
  }

  if (!canEdit.result && message.payload.payloadType === PayloadType.E2ee) {
    message.payload.e2eeData = oldPayload?.payload || '';
    message.payload.selfData = oldPayload?.selfPayload || '';
    message.payload.epoch = oldPayload.epoch;
    message.payload.senderDeviceId = oldPayload.senderDeviceId;
    message.payload.setDecodedText(oldPayload.text);
    return false;
  }

  await Tasks.messaging.editMessage(message);
  return true;
}
